import { render } from "./DashboardAlerts.vue?vue&type=template&id=68fca7ab"
import script from "./DashboardAlerts.vue?vue&type=script&lang=js"
export * from "./DashboardAlerts.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__